import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { useCallback, useState } from 'react'

import Layouts from '@/layouts/Layouts'

import AlbumContent from './AlbumContent'
import Banner from './Banner'

const Album = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const [filterFind, setFilterFind] = useState('')
  const [filterArea, setFilterArea] = useState<string | null>(null)
  const [filterYear, setFilterYear] = useState<string | null>(null)
  const [filterAreaDialog, setFilterAreaDialog] = useState<string | null>(null)
  const [filterYearDialog, setFilterYearDialog] = useState<string | null>(null)

  const handleChangeFind = useCallback((e: React.ChangeEvent<HTMLInputElement> | string) => {
    if (typeof e === 'string') {
      setFilterFind(e)
    } else {
      e.preventDefault()

      setFilterFind(e.target.value)
    }
  }, [])

  const handleChangeArea = useCallback((value: string) => {
    setFilterArea(value)
  }, [])

  const handleChangeYear = useCallback((value: string) => {
    setFilterYear(value)
  }, [])

  const handleResetFilter = () => {
    setFilterFind('')
    setFilterArea(null)
    setFilterYear(null)
    setFilterAreaDialog(null)
    setFilterYearDialog(null)
  }

  return (
    <Layouts
      title={t('album:title')}
      description={t('album:description')}
    >
      <div className='w-full bg-white pt-14 lg:pt-18'>
        <Banner
          filterArea={filterArea}
          filterFind={filterFind}
          filterYear={filterYear}
          handleChangeArea={handleChangeArea}
          handleChangeFind={handleChangeFind}
          handleChangeYear={handleChangeYear}
          handleResetFilter={handleResetFilter}
          dialog={{
            filterAreaDialog,
            setFilterAreaDialog,
            filterYearDialog,
            setFilterYearDialog,
          }}
        />

        <AlbumContent
          locale={router.locale}
          filterArea={filterArea}
          filterFind={filterFind}
          filterYear={filterYear}
          handleResetFilter={handleResetFilter}
        />
      </div>
    </Layouts>
  )
}

export default Album
